
import { motion } from "framer-motion";
import { Users, Bell, TrendingUp, Calendar, CreditCard, ShieldCheck, Calculator, CheckCircle, FileBarChart } from "lucide-react";
import FeatureCard from "./FeatureCard";

const FeaturesSection = () => {
  const features = [
    {
      title: "Member Management",
      description: "Organize and track all members across multiple chit funds with ease",
      icon: <Users className="h-6 w-6 text-primary" />,
      delay: 0.1
    },
    {
      title: "Flexible Monthly Amounts",
      description: "Configure same or different contribution amounts for each month",
      icon: <Calculator className="h-6 w-6 text-primary" />,
      delay: 0.2
    },
    {
      title: "Payment Tracking",
      description: "Track member payments month-by-month with complete payment history",
      icon: <CheckCircle className="h-6 w-6 text-primary" />,
      delay: 0.3
    },
    {
      title: "Automated Reminders",
      description: "Send automated reminders for upcoming payment dates",
      icon: <Bell className="h-6 w-6 text-primary" />,
      delay: 0.4
    },
    {
      title: "Analytics Dashboard",
      description: "Get insights into your chit funds with detailed analytics",
      icon: <TrendingUp className="h-6 w-6 text-primary" />,
      delay: 0.5
    },
    {
      title: "Payment Scheduler",
      description: "Schedule and track all payment collections seamlessly",
      icon: <Calendar className="h-6 w-6 text-primary" />,
      delay: 0.6
    },
    {
      title: "Loan Management",
      description: "Track loans, interest payments and manage borrowers",
      icon: <CreditCard className="h-6 w-6 text-primary" />,
      delay: 0.7
    },
    {
      title: "Secure Platform",
      description: "Enterprise-grade security to protect your sensitive financial data",
      icon: <ShieldCheck className="h-6 w-6 text-primary" />,
      delay: 0.8
    },
    {
      title: "Export & Reports",
      description: "Generate detailed reports and export data in multiple formats",
      icon: <FileBarChart className="h-6 w-6 text-primary" />,
      delay: 0.9
    }
  ];

  return (
    <section id="features" aria-labelledby="features-heading" className="py-16 md:py-20 px-4 md:px-8 bg-background relative">
      {/* Subtle pattern/gradient background */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_bottom_left,hsl(var(--accent)/0.2),transparent_70%)]"></div>
      
      <div className="max-w-7xl mx-auto relative">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
          className="text-center mb-12 md:mb-16"
        >
          <h2 id="features-heading" className="text-2xl md:text-3xl lg:text-4xl font-bold mb-4">Powerful Features To Manage Your Chit Funds</h2>
          <p className="text-muted-foreground max-w-2xl mx-auto text-base md:text-lg px-4">
            Everything you need in one place to run your chit fund business efficiently
          </p>
        </motion.div>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {features.map((feature, index) => (
            <FeatureCard
              key={index}
              title={feature.title}
              description={feature.description}
              icon={feature.icon}
              index={index}
              delay={feature.delay}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
